__turbopack_context__.v({
  "actions": "EditPatient-module___aJfPq__actions",
  "actionsEnd": "EditPatient-module___aJfPq__actionsEnd",
  "container": "EditPatient-module___aJfPq__container",
  "row": "EditPatient-module___aJfPq__row",
});
